import React, { useState, useEffect } from "react";
import { Button, Tooltip, notification } from "antd";
import Table from "../table/SiReportTable";
import { HiOutlineInboxArrowDown } from "react-icons/hi2";
import SIFilter from "../SiFilter";
import Utils from "../../../../utility/Utils";
import { CSVLink } from "react-csv";
import dbstorage from "../../../../lib/DBStorage";

import notificationFilter from "../../../../components/NotificationFilter";
import { useComponentStore } from "../../../../components/ComponentsStore";
const Overall = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { setNotificationCount } = useComponentStore();
  const fetchData = async () => {
    try {
      setLoading(true);
      const siData = await SIFilter.getSIReport();
      setTableData(siData);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };
  const [api, contextHolder] = notification.useNotification();
  const noDataNotification = () => {
    api.info({ title: "No Data Available !",
      placement: "bottomRight",
      style: { backgroundColor: "#ceddf5" },
      duration: 2,
    });
  };
  const handleDownloadClick = async () => {
    if (!tableData.length) {
      noDataNotification();
      return;
    } else {
      await download();
    }
  };
  const download = async () => {
    try {
      let userid;
      await dbstorage.get("user").then((user) => {
        userid = user._id;
      });

      await notificationFilter.createCsv("si_report", userid,"","","","");
      const count = await notificationFilter.getCount(userid);

      setNotificationCount(count.count);

      // return transformedCsvData;
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const headers = [
    { label: "Customer Name", key: "customer_details" },
    {
      label: "Customer Contact",
      key: "customer_contact_details",
    },
    {
      label: "Customer Address",
      key: "customer_contact_address_details",
    },
    { label: "SI Name", key: "si_details" },
    { label: "SI Contact", key: "si_contact_details" },
    { label: "Gateway Sr No", key: "gateway_serial_number" },
    { label: "Installation Start Time", key: "start_time" },
    { label: "Installation End Time", key: "end_time" },
    {
      label: "Total Installation Time In Hours",
      key: "total_hours",
    },
  ];

  return (
    <div className="card-background">
      <div className="d-flex justify-content-between ms-2 align-items-center">
        <div className="card-heading ">
          Date : {new Date().getDate()}-{new Date().getMonth() + 1}-
          {new Date().getFullYear()}
        </div>

        <div className="card-heading ">SI Report</div>
        <Button
          className="border-0 shadow-none me-4"
          icon={
            <Tooltip title="Download">
              <span>
                <HiOutlineInboxArrowDown className="text-color-grey fs-4" />
              </span>
            </Tooltip>
          }
          type="text"
          onClick={handleDownloadClick}
        />
      </div>
      <Table tableData={tableData} loading={loading} />
    </div>
  );
};

export default Overall;
